<template>
    <div>
        <template v-if="Object.keys(referencesData).length == 0 && !isLoadingData">
            <div class="alert alert-warning" role="alert">
                No hay datos disponibles para mostrar.
            </div>
        </template>
        <template v-else-if="isLoadingData">
            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </template>
        <template v-else>
            <ConfectionProductionReportingRadarGraphicData :referencesData="referencesData" />
        </template>
    </div>
</template>

<script>
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import ConfectionProductionReportingRadarGraphicData from './ConfectionProductionReportingRadarGraphicData.vue';
export default {
    name: 'ConfectionProductionReportingRadarGraphicDataContainer',
    components: {
        SpeenComponent,
        ConfectionProductionReportingRadarGraphicData,
    },
    props: {
        referencesData: {
            type: Object,
            required: true,
        },
        isLoadingData: {
            type: Boolean,
            default: false,
        },
    },
};
</script>